import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {WizardInformacion} from "../../interface/wizard-informacion.types";
import { DataWizardService } from '../../services/data-wizard.service';

@Component({
    selector: 'lib-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

    @Input()
    informacionWizard: WizardInformacion;
    private _unsubscribeAll: Subject<any> = new Subject<any>();


    constructor(private dataWizardService: DataWizardService) {
    }

    ngOnInit(): void {
        this.obSerbarCambiosDataExpediente();
    }

    validarRouter() {
        if (this.informacionWizard.edicion) {
            if(this.informacionWizard.idDiligencia){
                return ['../../..'];
            }else{
                return ['../..'];
            }
        } else {
            return ['..'];
        }
    }

    public obSerbarCambiosDataExpediente() {
        this.dataWizardService.dataFolio.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
            if(response && typeof response == "string"){
                this.informacionWizard.folioNegocio = response;
            }
        });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
